import React, { useCallback, useEffect } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { Button } from '@daedalus/atlas/Button';
import { Portal } from '@daedalus/atlas/helpers/Portal';
import { Icon } from '@daedalus/atlas/Icon';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wpjryrc",
  propsAsIs: false
});
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c2gvyim",
  propsAsIs: false
});
const CloseButtonWrapper = /*#__PURE__*/styled('div')({
  name: "CloseButtonWrapper",
  class: "cr4mwcc",
  propsAsIs: false
});
const ModalBackground = /*#__PURE__*/styled('div')({
  name: "ModalBackground",
  class: "m1g282k3",
  propsAsIs: false
});
interface Props {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  hasShadeBackground?: boolean;
  dataTestId?: string;
}
export const Modal: React.FC<Props> = ({
  children,
  isOpen,
  onClose,
  hasShadeBackground = true,
  dataTestId = 'modal'
}) => {
  const onCloseModal = useCallback((event: React.SyntheticEvent<Element, Event>) => {
    onClose();
    event.stopPropagation();
  }, [onClose]);
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape' || event.key === 'Esc') onClose();
    };

    // Add the event listener when the component mounts
    document.addEventListener('keydown', handleEscape);

    // Remove the event listener when the component unmounts
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);
  useEffect(() => {
    if (isOpen) document.body.style.overflowY = 'hidden';
    return () => {
      document.body.style.overflowY = 'auto';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <Portal>
      <Wrapper data-testId={dataTestId}>
        <ModalBackground onClick={onCloseModal} className={cx(hasShadeBackground && 'hasShadeBackground')} />
        <ContentWrapper>
          {children}
          <CloseButtonWrapper data-testId="close-modal-wrapper">
            <Button dataId="OverlayPageCloseButton" onClick={onCloseModal} variant="secondary" iconStart={<Icon name="Close" />} isRounded />
          </CloseButtonWrapper>
        </ContentWrapper>
      </Wrapper>
    </Portal>;
};

require("./Modal.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Modal.tsx");